// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"d18a41e427077883","5410":"0b54d0448a61be10","7394":"9c03695983d69cd7"}[chunkId] + ".css";
};